import { render, staticRenderFns } from "./BindsPasswordOffIcon.vue?vue&type=template&id=c8ed0f56&"
import script from "./BindsPasswordOffIcon.vue?vue&type=script&lang=js&"
export * from "./BindsPasswordOffIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports